export default ($axios, baseUrl) => ({
  post(email) {
    return $axios.get(`${baseUrl}subscribe/email?emailAddress=` + email)
  },
})
